<ng-container *ngIf="licensed">
	<app-kiosk-idle *ngIf="!kioskService.activeOrder?.value" (startOrderEmitter)="kioskService.kioskOrderStart()"></app-kiosk-idle>
	<app-kiosk-menu *ngIf="kioskService.activeOrder"></app-kiosk-menu>
	<app-kiosk-order *ngIf="kioskService.activeOrder"></app-kiosk-order>
</ng-container>

<app-kiosk-license
	*ngIf="!licensed"
	[licensed]="licensed.value"
	(licensedChange)="licensed.next($event)"
	[venueKey]="kioskService.venueService.venueKey"
></app-kiosk-license>
